import React from 'react';

const CapituloTesis = props => {
  const { author, year, title, university, url } = props;
  return (
    <li>
      <div className="quote">
        <span className="chapter-thesis">
          {
            // author
            author && author
          }
          {
            // año
            year && ` (${year}). `
          }
          {
            // titulo
            title && <em>{`${title}. `}</em>
          }
          {
            // universidad
            university && `${university}. `
          }
        </span>
        {
          // url
          url && (
            <a className="quote-url" href={url}>
              Link
            </a>
          )
        }
      </div>
    </li>
  );
};

export default CapituloTesis;
